var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9316 2.75635H5.49414C4.71852 2.75635 4.08789 3.38729 4.08789 4.1626C4.08789 4.93822 4.71852 5.56885 5.49414 5.56885H14.9316C15.707 5.56885 16.3379 4.93822 16.3379 4.1626C16.3379 3.38729 15.707 2.75635 14.9316 2.75635ZM14.9316 7.44385H5.49414C4.71852 7.44385 4.08789 8.07479 4.08789 8.8501C4.08789 9.62572 4.71852 10.2563 5.49414 10.2563H14.9316C15.707 10.2563 16.3379 9.62572 16.3379 8.8501C16.3379 8.07479 15.707 7.44385 14.9316 7.44385ZM14.9316 12.1313H5.49414C4.71852 12.1313 4.08789 12.7623 4.08789 13.5376C4.08789 14.3132 4.71852 14.9438 5.49414 14.9438H14.9316C15.707 14.9438 16.3379 14.3132 16.3379 13.5376C16.3379 12.7623 15.707 12.1313 14.9316 12.1313ZM1.74414 2.75635C0.968516 2.75635 0.337891 3.38729 0.337891 4.1626C0.337891 4.93822 0.968516 5.56885 1.74414 5.56885C2.51945 5.56885 3.15039 4.93822 3.15039 4.1626C3.15039 3.38729 2.51945 2.75635 1.74414 2.75635ZM1.74414 7.44385C0.968516 7.44385 0.337891 8.07479 0.337891 8.8501C0.337891 9.62572 0.968516 10.2563 1.74414 10.2563C2.51945 10.2563 3.15039 9.62572 3.15039 8.8501C3.15039 8.07479 2.51945 7.44385 1.74414 7.44385ZM1.74414 12.1313C0.968516 12.1313 0.337891 12.7623 0.337891 13.5376C0.337891 14.3132 0.968516 14.9438 1.74414 14.9438C2.51945 14.9438 3.15039 14.3132 3.15039 13.5376C3.15039 12.7623 2.51945 12.1313 1.74414 12.1313Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.337891 0.850098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.3f60c34d8235ba09ee98236e2a30b85a.svg";
export { ForwardRef as ReactComponent };